import Markdown from 'markdown-to-jsx'
import {
  Box, Typography, Table, TableBody,
  TableRow, TableCell, Button, Stack
} from "@mui/material"
import { translate } from "../../utils/localisation"

interface Props {
  markdown: string
  loading: boolean
  onDownload: () => void
}

export default function SummaryView({ markdown, loading, onDownload }: Props) {
  return (
    <Box sx={{ mt: 2, p: 4, border: 1, borderColor: "gray", borderRadius: 2 }}>
      {!loading && markdown ?
        ("")
        : <Typography variant="h4" gutterBottom>
            {translate("clinic-summary-screen.getSummarySection.clinicSummary")}
          </Typography>
      }

      <Table>
        <TableBody>
          <TableRow>
            <TableCell
              colSpan={2}
              sx={{ backgroundColor: "#f5f5f5", verticalAlign: "top" }}
            >
              {loading
                ? <Typography>Process With LLM Loading…</Typography>
                : markdown
                  ? <Markdown>{markdown}</Markdown>
                  : <Typography color="text.secondary">
                      {translate("clinic-summary-screen.getSummarySection.no_data")}
                    </Typography>
              }
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={2} align="right">
              <Stack direction="row" spacing={1}>
                <Button
                  variant="contained"
                  onClick={onDownload}
                  disabled={!markdown}
                >
                  {translate("clinic-summary-screen.getSummarySection.downloadSummary")}
                </Button>
              </Stack>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  )
}
